import { useState, useEffect, useRef, useCallback } from "react";
import styles from "../../App.module.css";
import { FaCheck, FaTimes, FaWhatsapp, FaWpforms } from "react-icons/fa";
import api from "../../api/axios";
import { format, parseISO } from "date-fns";
import ModalFinalizar from "../../components/ModalFinalizar";
import ListaFormularios from "../../components/ListaFormularios";

const Pendencias = ({ userPermission, userCpf }) => {
  const [usersList, setUsersList] = useState([]);
  const [allUsersList, setAllUsersList] = useState([]);
  const [usersProdList, setUsersProdList] = useState([]);
  const [allUsersProdList, setAllUsersProdList] = useState([]);
  const [pendenciaOn, setPendenciaOn] = useState([]);
  const [pendenciaProdOn, setPendenciaProdOn] = useState([]);
  const [quarentenaData, setQuarentenaData] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataProd, setFilteredDataProd] = useState([]);

  const [filtroVendedorProd] = useState(0);
  const [filtroProdutor, setFiltroProdutor] = useState(0);
  const [filtroStatusProd] = useState(0);
  const [searchTerm] = useState("");

  const [usersListProd, setUsersListProd] = useState([]);
  const [isModalOpenAguardando, setIsModalOpenAguardando] = useState(false);
  const [isModalOpenFinalizado, setIsModalOpenFinalizado] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const textareaRef = useRef(null);
  const [vendedorProdutor, setVendedorProdutor] = useState([]);

  const groupColors = ["#8BAED3", "#F29098", "#808EA3", "#C0ECAE"];

  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "";

  const getDemanda = useCallback(async () => {
    try {
      const res = await api.get(
        `/usuariosComFormularios?userPermission=${userPermission}&CPF=${userCpf}`
      );
      const resAll = await api.get(`/allUsuariosComFormularios`);

      setAllUsersProdList(resAll.data.users || []);
      setUsersProdList(res.data.users || []);

      const { users } = res.data;

      if (!users || !Array.isArray(users)) {
        console.error("Erro: `users` não é um array válido:", users);
        setUsersListProd([]);
        setFilteredDataProd([]);
        return;
      }

      setUsersListProd(users);
      setFilteredDataProd(users);

      const resVendedores = await api.get("/vendedores-produtores");
      const usersvd = resVendedores.data?.data || [];
      setVendedorProdutor(usersvd);

      const produtoresComPendencias = usersvd.filter((vendedor) =>
        users.some(
          (item) =>
            item.produtor === vendedor.cpf &&
            [0, 2, 3, 5].includes(item.status)
        )
      );

      setPendenciaProdOn(produtoresComPendencias);
    } catch (error) {
      console.error("Erro ao buscar usuários e formulários:", error);
    }
  }, [userPermission, userCpf]);

  const fetchData = useCallback(async () => {
    try {
      const resUsers = await api.get(
        `/clientes?userPermission=${userPermission}&CPF=${userCpf}`
      );
      setUsersList(resUsers.data);

      const resAllUsers = await api.get(`/clientesAll`);
      setAllUsersList(resAllUsers.data);

      const resVendedores = await api.get("/vendedores-produtores");
      const users = resVendedores.data?.data || [];

      const vendedoresComPendencias = users.filter((vendedor) =>
        resUsers.data.some(
          (item) =>
            item.vendedor === vendedor.cpf &&
            [1, 3, 5].includes(item.status)
        )
      );

      setPendenciaOn(vendedoresComPendencias);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    }
  }, [userPermission, userCpf]);

  useEffect(() => {
    getDemanda();
    fetchData();
  }, [getDemanda, fetchData]);

  useEffect(() => {
    if (quarentenaData === 0) {
      setFilteredData([]);
    } else if (quarentenaData === 10) {
      setFilteredData(
        allUsersList.filter((item) => [1, 3, 5].includes(item.status))
      );
    } else {
      setFilteredData(
        usersList.filter(
          (item) =>
            [1, 3, 5].includes(item.status) &&
            item.vendedor === quarentenaData
        )
      );
    }
  }, [quarentenaData, usersList, allUsersList]);

  const updateStatus = async (id, statusDef) => {
    try {
      await api.post("/updateStatus", { id, status: statusDef });
      setUsersList((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: statusDef } : item
        )
      );
    } catch (error) {
      console.error("Erro ao atualizar status:", error);
    }
  };

  useEffect(() => {
    const normalizeText = (text) =>
      text
        ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        : "";

    if (filtroProdutor === 0) {
      setFilteredDataProd([]);
      return;
    }

    if (filtroProdutor === 10) {
      setFilteredDataProd(usersListProd);
      return;
    }

    setFilteredDataProd(
      usersListProd.filter((item) => {
        const statusMatch =
          filtroStatusProd === 0 ||
          item.produzirStatus === filtroStatusProd ||
          (filtroStatusProd === -2 &&
            (item.produzirStatus === 0 || item.produzirStatus === 2));

        const vendedorMatch =
          filtroVendedorProd === 0 || item.vendedor === filtroVendedorProd;

        const produtorMatch =
          filtroProdutor === 0 || item.produtor === filtroProdutor;

        const normalizedSearchTerm = normalizeText(searchTerm);

        const searchMatch =
          !searchTerm.trim() ||
          (item.login &&
            normalizeText(item.login).includes(normalizedSearchTerm)) ||
          item.formularios.some((formulario) => {
            const formularioData = JSON.parse(formulario.formularioData || "{}");
            return (
              normalizeText(
                `${formularioData.nome || ""} ${formularioData.sobrenome || ""}`
              ).includes(normalizedSearchTerm) ||
              (formularioData.telefones || []).some((tel) =>
                normalizeText(tel).includes(normalizedSearchTerm)
              ) ||
              (formulario.ds160_id &&
                normalizeText(formulario.ds160_id.toString()).includes(
                  normalizedSearchTerm
                ))
            );
          });

        return statusMatch && vendedorMatch && produtorMatch && searchMatch;
      })
    );
  }, [
    usersListProd,
    filtroVendedorProd,
    filtroProdutor,
    filtroStatusProd,
    searchTerm,
  ]);

  const handleClickAguardando = async (item) => {
    if (item.aguardando) {
      setInputValue(item.aguardando);
    }
    setCurrentUserId(item.produzirId);
    setIsModalOpenAguardando(true);
  };

  const handleClickFinalizado = async (item) => {
    setCurrentUserId(item.produzirId);

    if (item.aguardando) {
      setInputValue(item.aguardando);
    }
    if (item.login) {
      setLogin(item.login);
    }
    if (item.senha) {
      setSenha(item.senha);
    }

    setIsModalOpenFinalizado(true);
  };

  const handleSubmitAguardando = async () => {
    try {
      const response = await api.post("/updateStatusProducao", {
        id: currentUserId,
        aguardando: inputValue,
        status: 2,
      });

      if (response.status === 200) {
        setIsModalOpenAguardando(false);
        getDemanda();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error("Erro na solicitação de atualização:", error);
    }
  };

  const handleSubmitFinalizado = async () => {
    try {
      const response = await api.post("/updateStatusProducao", {
        id: currentUserId,
        aguardando: inputValue,
        status: 1,
        login: login.toString(),
        senha: senha.toString(),
      });

      if (response.status === 200) {
        setIsModalOpenFinalizado(false);
        getDemanda();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error("Erro na solicitação de atualização:", error);
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${Math.min(
        textareaRef.current.scrollHeight,
        400
      )}px`;
    }
  }, [inputValue]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className={styles.app}>
      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>Agendamentos (pendências)</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div style={{ width: "100%" }}>
          <div style={{ padding: "10px" }} />
          <div
            className={styles.filtroDeClientesContainer}
            style={{ marginTop: "10px" }}
          >
            <div className={styles.filterOptionsContainer}>
              <div className={styles.containerVendedor}>
                <div className={styles.inputStyleVendedor}>
                  {pendenciaOn.map((item) => (
                    <div key={item.cpf} className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButton}
                        onClick={() => setQuarentenaData(item.cpf)}
                      >
                        {item.nome}
                      </button>
                      <div className={styles.bolha}>
                        {
                          usersList.filter(
                            (u) =>
                              u.vendedor === item.cpf &&
                              [1, 3, 5].includes(u.status)
                          ).length
                        }
                      </div>
                    </div>
                  ))}

                  <div className={styles.setPendenciaDiv}>
                    <button
                      className={styles.setPendenciaButton}
                      onClick={() => setQuarentenaData(10)}
                    >
                      Todos
                    </button>
                    <div className={styles.bolha}>
                      {
                        allUsersList.filter((u) =>
                          [1, 3, 5].includes(u.status)
                        ).length
                      }
                    </div>
                  </div>

                  {quarentenaData !== 0 && (
                    <div className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButtonClose}
                        onClick={() => setQuarentenaData(0)}
                      >
                        X fechar
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.usersListContainer}>
          {filteredData.map((item) => {
            let dataHorarioEntrevista = "";

            if (item.entrevista) {
              try {
                const entrevista = JSON.parse(item.entrevista);
                if (entrevista.data_horario) {
                  dataHorarioEntrevista = format(
                    parseISO(entrevista.data_horario),
                    "dd-MM-yy"
                  );
                }
              } catch (error) {
                console.error("Erro ao parsear entrevista:", error);
              }
            }

            return (
              <div
                key={item.id}
                style={{
                  width: "100%",
                  backgroundColor: "var(--corPrimaria)",
                  borderRadius: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    color: "white",
                    textAlign: "center",
                    padding: "10px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "0 1 auto" }}>
                    <p>
                      <b>{dataHorarioEntrevista}</b>
                    </p>
                  </div>

                  <div style={{ flex: "1 1 auto" }}>
                    <p className={styles.loginContainer2}>{item.login}</p>
                  </div>

                  <div style={{ flex: "0 1 auto", paddingRight: "20px" }}>
                    {item.vendedor !== 0 && (
                      <p className={styles.icon2}>
                        {vendedorProdutor.find((v) => v.cpf === item.vendedor)?.nome ||
                          "Vendedor não encontrado"}
                      </p>
                    )}
                  </div>
                </div>

                <div
                  style={{ width: "100%", padding: "10px" }}
                  onClick={() => navigator.clipboard.writeText(item.login)}
                >
                  <div style={{ width: "100%" }}>
                    <div className={styles.editIconBoxes}>
                      <div
                        onClick={() => updateStatus(item.id, 2)}
                        className={`${styles.editIconBox} ${styles.green} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaCheck /> <b>&nbsp;Data Final&nbsp;</b>
                        </p>
                      </div>

                      <div
                        onClick={() => updateStatus(item.id, 0)}
                        className={`${styles.editIconBox} ${styles.red} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaTimes /> <b>&nbsp;Retomar Fila&nbsp;</b>
                        </p>
                      </div>

                      <div
                        onClick={() => updateStatus(item.id, 2)}
                        className={`${styles.editIconBox} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaWhatsapp style={{ fontSize: "24px" }} />
                        </p>
                      </div>

                      <div
                        onClick={() => updateStatus(item.id, 2)}
                        className={`${styles.editIconBox} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaWpforms style={{ fontSize: "24px" }} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>DS-160 (pendências)</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div style={{ width: "100%" }}>
          <div
            className={styles.filtroDeClientesContainer}
            style={{ marginTop: "10px" }}
          >
            <div className={styles.filterOptionsContainer}>
              <div className={styles.containerVendedor}>
                <div className={styles.inputStyleVendedor}>
                  {pendenciaProdOn.map((item) => (
                    <div key={item.cpf} className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButton}
                        onClick={() => setFiltroProdutor(item.cpf)}
                      >
                        {item.nome}
                      </button>
                      <div className={styles.bolha}>
                        {
                          usersProdList.filter(
                            (u) =>
                              u.produtor === item.cpf &&
                              [0, 2, 3, 5].includes(u.status)
                          ).length
                        }
                      </div>
                    </div>
                  ))}

                  <div className={styles.setPendenciaDiv}>
                    <button
                      className={styles.setPendenciaButton}
                      onClick={() => setFiltroProdutor(10)}
                    >
                      Todos
                    </button>
                    <div className={styles.bolha}>
                      {
                        allUsersProdList.filter((u) =>
                          [0, 2, 3, 5].includes(u.status)
                        ).length
                      }
                    </div>
                  </div>

                  {filtroProdutor !== 0 && (
                    <div className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButtonClose}
                        onClick={() => setFiltroProdutor(0)}
                      >
                        X fechar
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "10px" }}>
            <ListaFormularios
              users={filteredDataProd.filter((item) => item.status !== 1)}
              groupColors={groupColors}
              onClickVer={async (user) => {
                try {
                  const res = await api.get(`/cliente/token-por-cliente/${user.clienteId}`);

                  if (res.data?.status && res.data?.token) {
                    window.location.href = `${origin}/formulario/${res.data.token}`;
                  } else {
                    window.location.href = `${origin}/formularios/${user.clienteId}`;
                  }
                } catch (error) {
                  console.error("Erro ao verificar token do cliente:", error);
                  window.location.href = `${origin}/formularios/${user.clienteId}`;
                }
              }}
              onClickFinalizar={handleClickFinalizado}
              onClickAguardar={handleClickAguardando}
              onClickAnalise={() => { }}
              tipo="pendencias"
            />
          </div>
        </div>
      </div>

      <ModalFinalizar
        open={isModalOpenFinalizado}
        onClose={() => setIsModalOpenFinalizado(false)}
        onSubmit={handleSubmitFinalizado}
        login={login}
        setLogin={setLogin}
        senha={senha}
        setSenha={setSenha}
        inputValue={inputValue}
        setInputValue={setInputValue}
        textareaRef={textareaRef}
      />

      {isModalOpenAguardando && (
        <div className={styles.modalProducao}>
          <div className={styles.modalContentProducao}>
            <h2>Observação do produtor</h2>
            <textarea
              ref={textareaRef}
              style={{
                width: "100%",
                minHeight: "50px",
                maxHeight: "400px",
                overflow: "auto",
                resize: "none",
              }}
              value={inputValue}
              onChange={handleInputChange}
            />
            <button onClick={handleSubmitAguardando}>Registrar</button>
            <button
              onClick={() => {
                setIsModalOpenAguardando(false);
                setInputValue("");
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pendencias;